/**
 * تطبیقِ نامِ محصولِ پارت با نامِ محصولِ نرخ‌نامه — همان قاعدهٔ سرور (`services/product_names.py`).
 *
 * 🐞 کدِ ۴۳۱: پارت «شورت زنانه» بود و نرخ‌نامه «شرت زنانه»؛ مقایسهٔ دقیق هیچ عملیاتی نمی‌دید.
 * کلید = حروفِ یکدست، بدونِ نیم‌فاصله/فاصله‌های اضافه، خط‌تیره‌ها یکی، املاهای رایج یکسان.
 */
const SPELLINGS = [["شورت", "شرت"], ["فانریب", "فانریپ"], ["تی شرت", "تیشرت"], ["تی‌شرت", "تیشرت"]];

export function productKey(name) {
  let s = String(name || "")
    .replace(/ي/g, "ی").replace(/ك/g, "ک").replace(/‌/g, "").replace(/ـ/g, "")
    .replace(/[—–_]/g, "-")
    .replace(/\s*-\s*/g, "-")
    .replace(/\s+/g, " ").trim().toLowerCase();
  for (const [a, b] of SPELLINGS) s = s.split(a).join(b);
  return s;
}

/** کلیدهای قابلِ قبول برای یک پارت: اول «محصول — مدل»، بعد «محصول». */
export function candidateKeys(order) {
  if (!order) return [];
  const keys = [];
  if (order.product_type && order.variant) keys.push(productKey(`${order.product_type} - ${order.variant}`));
  if (order.product_type) { const k = productKey(order.product_type); if (!keys.includes(k)) keys.push(k); }
  return keys;
}

/** ردیف‌های نرخ‌نامهٔ این پارت — اگر «محصول — مدل» وجود دارد فقط همان، وگرنه «محصول». */
export function ratesForOrder(rates, order) {
  if (!order) return rates || [];
  for (const k of candidateKeys(order)) {
    const hit = (rates || []).filter((c) => productKey(c.product_type) === k);
    if (hit.length) return hit;
  }
  return [];
}

/** نام‌های نرخ‌نامه که شبیهِ این محصول‌اند (برای پیامِ راهنما وقتی هیچ عملیاتی پیدا نشد). */
export function similarCatalogProducts(rates, order) {
  if (!order?.product_type) return [];
  const head = productKey(order.product_type).split("-")[0].split(" ")[0];
  return [...new Set((rates || []).map((c) => c.product_type))]
    .filter((n) => head && productKey(n).includes(head));
}
